import { defineMachine } from "../state-machine.js";
/** Inquiry lifecycle (docs/02-domain.md, "Inquiry and quote"). */
export const inquiry = defineMachine({
    name: "inquiry",
    states: ["open", "quoted", "countered", "accepted", "declined", "withdrawn", "expired"],
    events: ["quote", "counter", "accept", "decline", "withdraw", "expire"],
    initial: "open",
    transitions: {
        open: { quote: "quoted", decline: "declined", withdraw: "withdrawn", expire: "expired" },
        quoted: {
            quote: "quoted",
            counter: "countered",
            accept: "accepted",
            decline: "declined",
            withdraw: "withdrawn",
            expire: "expired",
        },
        countered: { quote: "quoted", decline: "declined", withdraw: "withdrawn", expire: "expired" },
        accepted: {},
        declined: {},
        withdrawn: {},
        expired: {},
    },
});
/** Each quote version is immutable; only its status moves. */
export const quoteVersion = defineMachine({
    name: "quote-version",
    states: ["issued", "countered", "accepted", "superseded", "expired"],
    events: ["counter", "accept", "supersede", "expire"],
    initial: "issued",
    transitions: {
        issued: { counter: "countered", accept: "accepted", supersede: "superseded", expire: "expired" },
        countered: { supersede: "superseded", expire: "expired" },
        accepted: {},
        superseded: {},
        expired: {},
    },
});
//# sourceMappingURL=inquiry.machine.js.map